import ErrorOutline from '@mui/icons-material/ErrorOutline'
import { useQuery } from '@tanstack/react-query'
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'
import useDialog from 'hooks/Shared/useDialog'
import useLoadingAdditionalInformation from 'hooks/Shared/useLoadingAdditionalInformation'
import { selectErrorDialog } from 'lib/helpers/errors.helpers'
import { downloadFileFromData } from 'lib/helpers/utilities'
import { QueryOptions } from 'models/general'
import { IInvoice, PaymentComplementFiles } from 'models/invoices.models'
import { getPaymentComplementFiles } from 'services/Invoices/invoices.services'

const useDownloadPaymentComplementFiles = (
  workspaceId: number,
  invoice?: IInvoice,
  paymentComplement?: any,
  options: QueryOptions<PaymentComplementFiles> = {}
) => {
  const dialog = useDialog()
  const showAdditionalInformationLoading = useLoadingAdditionalInformation()
  const { onSuccess, onError, noDialog } = options

  const query = useQuery<PaymentComplementFiles>(
    [
      'get-payment-complement-files-in-base64',
      workspaceId,
      invoice,
      paymentComplement,
    ],
    () => {
      if (!invoice || !invoice.idCfdi)
        throw new Error('CFDI cargado incorrectamente')
      if (!paymentComplement)
        throw new Error('Complemento de pago cargado incorrectamente')
      showAdditionalInformationLoading()
      return getPaymentComplementFiles(
        workspaceId,
        invoice.idCfdi,
        paymentComplement.idPayment
      )
    },
    {
      enabled: false,
      onSuccess: files => {
        dialog.close()
        onSuccess && onSuccess(files)
        downloadFileFromData(
          `${paymentComplement?.uuid || 'PDF'}.pdf`,
          files.pdf
        )
        downloadFileFromData(
          `${paymentComplement?.uuid || 'XML'}.xml`,
          files.xml
        )
      },
      onError: async (error: any) => {
        setTimeout(async () => {
          const op = selectErrorDialog(error)
          if (op?.variant) {
            await dialog[op.variant](op)
            return
          }

          if (!noDialog) {
            const rp = await dialog.dangerAsync({
              title: 'generic.error.title',
              subtitle:
                'No se pudo descargar el complemento de pago seleccionado.',
              icon: ErrorOutline as TModalIcon,
              primaryButtonText: 'Reintentar',
              secondaryButtonText: 'Cancelar',
            })

            if (rp) {
              query.refetch()
              return
            }
          }

          onError && onError(error)
        }, 600)
      },
    }
  )

  return query
}

export default useDownloadPaymentComplementFiles
